<template>
  <div class="layout-container py-32 desk:py-64 desktopMaxW-md">
    <div class="mx-auto">
      <div class="wysiwyg mb-32">
        <ExtendedWysiwyg v-if="pageContent" :content="pageContent" />
      </div>
      <ClaimsForm
        v-if="imageInstructions"
        :is-public="true"
        :image-instructions="imageInstructions"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ClaimsForm from '~/components/account/ClaimsForm.vue';
import { useGlobalContentStore } from '~/store/globalContent';
import { useUserStore } from '~/store/user';
import useLinkReplacer from '~/composables/useLinkReplacer';
import ExtendedWysiwyg from '~/components/globals/ExtendedWysiwyg.vue';

const globalContent = useGlobalContentStore();
const userStore = useUserStore();
const storyblokApi = useStoryblokApi();
const runtimeConfig = useRuntimeConfig();
const { accountUrl } = useLinkReplacer();

// Redirect logged-in users to account claims page
if (userStore.isLoggedIn) {
  await navigateTo(accountUrl('claims'));
}

const consumerTypeSettingsPath = globalContent.getConsumerTypeSettingsPath;
const claimsSettingsPath = `${consumerTypeSettingsPath}sitesettings/claims-settings`;

const { data } = await storyblokApi.get('cdn/stories/', {
  version: runtimeConfig.public.storyblokStoriesVersion as 'draft' | 'published',
  starts_with: claimsSettingsPath,
});

const claimsSettings = data?.stories?.[0]?.content;

// Redirect to account claims page if public claims page is not enabled in Storyblok
if (!claimsSettings?.enablePublicClaimsPage) {
  await navigateTo(accountUrl('claims'));
}

const pageContent = computed(() => {
  return claimsSettings?.claimsPageContent;
});

const imageInstructions = computed(() => {
  return claimsSettings?.imageInstructions;
});

definePageMeta({
  layout: 'default',
});
</script>
